import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { RasterCatCode } from 'src/app/server-api/models';
import { EnumDropdownComponent } from 'src/app/utils-flc/enum-dropdown/enum-dropdown.component';

@Component({
  selector: 'app-type-of-raster-dropdown',
  templateUrl: './type-of-raster-dropdown.component.html',
  styleUrls: ['./type-of-raster-dropdown.component.css']
})
export class TypeOfRasterDropdownComponent extends EnumDropdownComponent {

  constructor(
    public override translate: TranslateService,
    public override fb: FormBuilder
    ) {
    super(translate, fb);
  }

  override ngOnInit(): void {

    this.placeholderText = 'type-of-raster-dropdown.choose';

    super.ngOnInit();
  }

  override getItems(): void {

    super.getItems();
    this.items = [];
    
    this.items = Object.keys(RasterCatCode).map(key => RasterCatCode[key]);
            
    this.setPreSelect(this.preSelect);
  }
}



